module.exports = __webpack_public_path__ + "img/social-media.c4f9c2a.png";